import React, { useEffect, useContext } from "react";
import { Range } from "react-range";

import { WizardContext } from "../index";

import LocationPicker from "./layouts/LocationPicker";
import PerDaysSelection from "./layouts/PerDaysSelection";
export default function StepOne() {
  const {
    teamSize,
    setTeamSize,
    teamOption,
    setTeamOption,
    locationType,
    setLocationType,
  } = useContext(WizardContext);

  useEffect(() => {
    setTimeout(() => {
      jQuery(".appStep1").addClass("visible");
    }, 100);
  }, []);
  return (
    <div className="appStep1">
      <div className="stepContent">
        <ul>
          <li>
            <h5>Just you or your teammates, too?</h5>
            <div className="field-group-choice">
              <div className="choice">
                <input
                  type="radio"
                  onChange={() => {
                    setTeamOption("team");
                    setTeamSize(2);
                  }}
                  id="team"
                  checked={teamOption == "team" ? true : false}
                  value="team"
                />
                <label htmlFor="team">Team</label>
              </div>
              <div className="choice">
                <input
                  type="radio"
                  onChange={() => {
                    setTeamOption("solo");
                    setTeamSize(1);
                  }}
                  id="solo"
                  checked={teamOption == "solo" ? true : false}
                  value="solo"
                />
                <label htmlFor="solo">Solo</label>
              </div>
            </div>
          </li>
          {teamOption == "team" && (
            <li>
              <h5>How many in your team?</h5>
              <div className="rangeSlider">
                <span className="minLabel">2</span>
                <Range
                  step={1}
                  min={2}
                  max={11}
                  values={[teamSize]}
                  onChange={(values) => setTeamSize(values[0])}
                  renderTrack={({ props, children }) => {
                    const percent = ((teamSize - 2) / (11 - 2)) * 100;

                    return (
                      <div className="trackbar" {...props}>
                        <div
                          className="trackProgress"
                          style={{
                            width: `${percent}%`,
                          }}
                        />
                        {children}
                      </div>
                    );
                  }}
                  renderThumb={({ props, value }) => (
                    <div className="handle" {...props}>
                      {value == 11 ? "10+" : value}
                    </div>
                  )}
                />
                <span className="maxLabel">10+</span>
              </div>
            </li>
          )}
          <li>
            <h5>How often do you need the workspace?</h5>
            {teamOption == "team" && (
              <p>
                Select how many days you would like on average per team member.
                For example, a 4-person team choosing 4 days/month = 16 day
                passes per month. You can share day passes across your team
                however you like!
              </p>
            )}
            <div className="colWrap">
              <PerDaysSelection />
            </div>
          </li>
          <li>
            <h5>Where do you want to work?</h5>
            <div className="field-group-choice">
              <div className="choice">
                <input
                  type="radio"
                  onChange={() => {
                    setLocationType("single");
                  }}
                  id="single"
                  checked={locationType == "single" ? true : false}
                  value="single"
                />
                <label htmlFor="single">Single space access</label>
              </div>
              <div className="choice">
                <input
                  type="radio"
                  onChange={() => {
                    setLocationType("all_locations");
                  }}
                  id="all_locations"
                  checked={locationType == "all_locations" ? true : false}
                  value="all_locations"
                />
                <label htmlFor="all_locations">All space access</label>
              </div>
            </div>
          </li>
          <li>
            <h5>Choose your home location</h5>
            <p>
              Going for all locations? Great! You'll still need to choose a home
              base for your induction - where we'll sort your access pass and
              run through everything you need to know.
            </p>
            <LocationPicker />
          </li>
        </ul>
      </div>
    </div>
  );
}
